const features = {
  embedInlineEntry: 'feature-at-09-2018-structured-text-inline-entries'
};

export default features;



// WEBPACK FOOTER //
// ./src/javascripts/app/widgets/structured_text/features.es6.js